// third-party

// assets
import { Story, People, Save2, ProfileTick, Bill, UserTick, UserRemove } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  widgets: Story,
  users: People,
  watchList: Save2,
  admin: ProfileTick,
  orderpositions: Bill,
  complete: UserTick,
  incomplete: UserRemove,
};

// ==============================|| MENU ITEMS - USERS ||============================== //
// TODO: fix translation error=> remove other languages
const usersSection: NavItemType = {
  id: 'group-users',
  title: 'Home',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'collapse',
      children: [
        {
          id: 'complete-users',
          title: 'Complete Users',
          type: 'item',
          url: '/users/complete',
          icon: icons.complete
        },
        {
          id: 'icomplete-users',
          title: 'Incomplete Users',
          type: 'item',
          url: '/users/incomplete',
          icon: icons.incomplete
        },
      ],
      // url: '/users',
      icon: icons.users
    },
    {
      id: 'order-positions',
      title: 'Order Positions',
      type: 'item',
      url: '/order-positions',
      icon: icons.orderpositions
    },
    {
      id: 'employees',
      title: 'Employees',
      type: 'item',
      url: '/employees',
      icon: icons.admin
    }
    // {
    //   id: 'watch-list',
    //   title: 'Watch List',
    //   type: 'item',
    //   url: '/watch-list',
    //   icon: icons.watchList
    // }
  ]
};

export const usersSectionDefault: NavItemType = {
  id: 'group-users',
  title: 'Home',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'users',
      title: 'Users',
      type: 'item',
      url: '/users',
      icon: icons.users
    }
  ]
};
export default usersSection;
